import React from 'react';
import DatePicker from 'react-datepicker';

import { CustomInput } from '@/components/utils/DatePicker/CustomInput';

export type StartsOnDatePickerInnerProps = {
  selected: Date | null;
  onChange: (date: Date) => void;
  minDate: Date;
  maxDate: Date;
  dateFormat: string;
};

export const StartsOnDatePickerInner: React.FC<
  StartsOnDatePickerInnerProps
> = ({ selected, onChange, minDate, maxDate, dateFormat }) => {
  return (
    <DatePicker
      selected={selected}
      onChange={(date: Date | null) => date instanceof Date && onChange(date)}
      minDate={minDate}
      maxDate={maxDate}
      dateFormat={dateFormat}
      customInput={<CustomInput />}
      dayClassName={(date) => {
        const day = date.getDay();
        if (day === 0) return 'react-datepicker__day--sun';
        if (day === 6) return 'react-datepicker__day--sat';
        return '';
      }}
    />
  );
};
